import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SageEntityTypeName } from '../../../../shared/services/sage-integration.model';
import { RematchRow, SageErrorFixStore } from './sage-error-fix.store';

/**
 * Wrong matches: shows both sides of each record. Adding it as new happens here; picking another
 * Aivor record happens on the record type's matching screen (decided 26/10/2026).
 */
@Component({
  selector: 'app-rematch-fix',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './rematch-fix.component.html',
  styleUrls: ['../onboarding-wizard/sage-wizard.shared.css', '../sage-mockup.shared.css', './fix-section.shared.css'],
})
export class RematchFixComponent {
  @Input({ required: true }) store!: SageErrorFixStore;
  @Input() syncEnabled = true;

  @Output() openMatching = new EventEmitter<SageEntityTypeName>();

  readonly trackRow = (_: number, r: RematchRow) => r.record.id;
}
